'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./or-divider.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A horizontal rule with the word "OR" appearing over the center
 */
var OrDivider = function (_React$Component) {
    _inherits(OrDivider, _React$Component);

    function OrDivider() {
        _classCallCheck(this, OrDivider);

        return _possibleConstructorReturn(this, (OrDivider.__proto__ || Object.getPrototypeOf(OrDivider)).apply(this, arguments));
    }

    _createClass(OrDivider, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'm-or-divider' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-or-divider--or' },
                    'or'
                ),
                _react2['default'].createElement('div', { className: 'm-or-divider--rule' })
            );
        }
    }]);

    return OrDivider;
}(_react2['default'].Component);

exports['default'] = OrDivider;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/or-divider.jsx
 ** module id = 1007
 ** module chunks = 0
 **/